// Utility layer (TS-2.5.04) - pure, no side effects. A ProductRecord <-> string-form projection,
// mirroring projects/lib/referenceValueDraft.ts's shape for this entity: the two owner fields keep
// NULL rather than becoming empty on submit (D-012's "nobody filled this in" vs. "somebody cleared
// it"), the same rule PortfolioDataManager.Sanitize applies server-side.
import type { ProductRecord } from "../../../api/generated/contracts";

export interface ProductDraft {
  readonly key: string | null;
  readonly name: string;
  readonly technologyOwner: string;
  readonly businessOwner: string;
  readonly isActive: boolean;
  readonly concurrencyToken: string | null;
}

export const EMPTY_PRODUCT_DRAFT: ProductDraft = {
  key: null,
  name: "",
  technologyOwner: "",
  businessOwner: "",
  isActive: true,
  concurrencyToken: null,
};

export function draftFromProduct(product: ProductRecord): ProductDraft {
  return {
    key: product.key,
    name: product.name,
    technologyOwner: product.technologyOwner ?? "",
    businessOwner: product.businessOwner ?? "",
    isActive: product.isActive,
    concurrencyToken: product.concurrencyToken,
  };
}

function blankToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length === 0 ? null : trimmed;
}

export function productFromDraft(draft: ProductDraft): ProductRecord {
  return {
    key: draft.key,
    name: draft.name.trim(),
    technologyOwner: blankToNull(draft.technologyOwner),
    businessOwner: blankToNull(draft.businessOwner),
    isActive: draft.isActive,
    concurrencyToken: draft.concurrencyToken,
    updatedAtUtc: null,
    updatedBy: null,
  };
}
